import * as _ from "lodash";
import * as React from "react";
import { MealSlots } from "../utils/AppConstants";

export interface CalorieDistributionProps {
    calorieDistribution: any,
    totalCaloriesPerDay: number,
    updateCalorieDistribution: (calorieDistribution: any) => void
}

export interface CalorieDistributionState {
    selectedSlots: string[],
    // calorieDistribution: any
}

class CalorieDistribution extends React.Component<CalorieDistributionProps, CalorieDistributionState> {
    constructor(props: CalorieDistributionProps) {
        super(props);
        this.state = {
            selectedSlots: !_.isEmpty(props.calorieDistribution) ? this.calculatedSelectedSlots(props.calorieDistribution) : []
            // calorieDistribution: !_.isEmpty(props.calorieDistribution) ? props.calorieDistribution : null
        }
    }
    calculatedSelectedSlots = (calorieDistribution: any) => {
        let selectedSlots: string[] = []
        _.map(calorieDistribution, (value, key) => {
            selectedSlots.push(key);
        })
        return selectedSlots;
    }
    onSelectionChange = (slotId: string) => {
        let selectedSlots = [...this.state.selectedSlots];
        // let calorieDistribution = {...this.state.calorieDistribution};
        if (selectedSlots.indexOf(slotId) !== -1) {
            selectedSlots.splice(selectedSlots.indexOf(slotId), 1);
            // !_.isEmpty(calorieDistribution) && calorieDistribution[slotId] ? delete calorieDistribution[slotId] : null;
        } else {
            selectedSlots.push(slotId);
            // calorieDistribution[slotId] = 0;
        }
        this.setState({
            selectedSlots,
            // calorieDistribution
        }, () => {
            this.setCalorieDistribution();
        })
    }
    setCalorieDistribution = () => {
        const calorieDistribution: {[key: string]: number} = {};
        this.state.selectedSlots.forEach((slot: string) => {
            calorieDistribution[slot] = 0;
        })
        this.props.updateCalorieDistribution(calorieDistribution);
    }
    render() {
        let selectedSlots = this.state.selectedSlots;
        // let calorieDistribution = this.state.calorieDistribution;
        // let totalEnteredCalories = this.getTotalEnteredCalories();
        return (
            <div className={"calorie-distribution-container animated slideFromTop"}>
                {
                    _.map(MealSlots, (slot, key) => {
                        let isSelected = selectedSlots.indexOf(key) !== -1;
                        // let inputValue = !_.isEmpty(calorieDistribution) && AppUtils.isDefined(calorieDistribution[key]) ? calorieDistribution[key] : "";
                        return <div className={"meal-slot-item"} key={`meal-slot-calorie-decider-${key}`}>
                            <div className={"check-box"}>
                                <input type="checkbox" checked={isSelected} onChange={() => this.onSelectionChange(key)}/>
                            </div>
                            <div className={`label ${isSelected ? "active" : ""}`}>{slot}</div>
                            {/*<div className={"value"}>*/}
                                {/*<TextInput value={inputValue} name={`${slot}-calorie-input`} onChange={this.onCalorieChange} onChangeCallbackMeta={key} disabled={!isSelected}/>*/}
                            {/*</div>*/}
                        </div>
                    })
                }
                {/*<div className={"button-container"}>*/}
                    {/*{*/}
                        {/*totalEnteredCalories > this.props.totalCaloriesPerDay &&*/}
                            {/*<span className={"incorrect-calorie-distribution brandon-bold"}>*/}
                                {/*<span className="glyphicon glyphicon-remove-circle" />*/}
                                {/*Calorie distribution exceeds total calories specified for the day*/}
                            {/*</span>*/}
                    {/*}*/}
                    {/*<span className={"total-calories brandon-bold"}>{this.getTotalEnteredCalories()}/{this.props.totalCaloriesPerDay} kcal</span>*/}
                    {/*<input disabled={totalEnteredCalories !== this.props.totalCaloriesPerDay} type="button" value="Set Calorie Distribution" onClick={this.setCalorieDistribution} />*/}
                {/*</div>*/}
            </div>
        )
    }
}

export default CalorieDistribution;